export const SET_STATUS = 'SET_STATUS';
export function setStatus(status) {
  return {
    type: SET_STATUS,
    status,
  };
}
